'use client';

import { UserProfile } from '@/entities/user-profile';
import { WarningIcon } from '@phosphor-icons/react/dist/ssr';
import { Button } from '@/shared/ui/core';
import { ReportDialog } from '../report-dialog';
import styles from './report-action.module.scss';


type ComponentProps = {
    profile: UserProfile | null;
};


export function ReportAction ({ profile }: ComponentProps) {
    return (
        <ReportDialog
            your_email={ profile?.email ?? '' }
            trigger={
                <Button
                    leftIcon={ <WarningIcon/> }
                    className={ styles.root }
                >
                    Report your incident
                </Button>
            }
        />
    );
}
